import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = {
  activeFileUploadAreaData: {
    // for a row or where ever this dialog area is opened.
    // so that can be used for configure multiple times using dialog.
    linkKey: null,
    uploadAreaFiles: [],
  },
};
const FileUploadAreaAndPreviewReducer = createSlice({
  name: "fileUploadAreaAndPreview",
  initialState: initialStateValue,
  reducers: {
    updateUploadAreaFiles(state, action) {
      // structure will be as below for object inside the array.
      // {linkKey:null, files:[{fileName:"", file: Object}]}
      state.activeFileUploadAreaData.uploadAreaFiles = action.payload;
    },
    updateLinkKey(state, action) {
      state.activeFileUploadAreaData.linkKey = action.payload;
    },
    resetToInitialState(state, action) {
      state = { ...initialStateValue };
    },
  },
});
export const FileUploadAreaAndPreviewReducerAction =
  FileUploadAreaAndPreviewReducer.actions;
export default FileUploadAreaAndPreviewReducer.reducer;
